import PropTypes from "prop-types";
import { useId, useState } from "react";
import { Button, Modal } from "react-bootstrap";

import linkedIcon from "../../../assets/TFlinked.svg";
import unlinkedIcon from "../../../assets/TFnotlinked.svg";
import InviteTreatmentModal from "../modals/invite-treatment-modal/invite-treatment-modal";

import ProviderChatPopup from "./ProviderChatPopup";
import { canMessageProvider } from "./providerChat.mjs";

import "./treatment-header.css";

const TreatmentFirstStatus = ({ provider, specialty, refetchAll }) => {
  const [show, setShow] = useState(false);
  const [showInvite, setShowInvite] = useState(false);
  const titleId = useId();
  const canMessage = canMessageProvider(provider);
  const label = canMessage
    ? "TreatmentFirst account activated — Send chat message"
    : "TreatmentFirst account required for chat";

  return (
    <>
      <button
        type="button"
        className="treatment-header-tf-status"
        title={label}
        aria-label={label}
        onClick={(event) => {
          event.stopPropagation();
          setShow(true);
        }}
      >
        <img src={canMessage ? linkedIcon : unlinkedIcon} alt="" width={25} height={25} />
      </button>
      {show &&
        (canMessage ? (
          <ProviderChatPopup provider={provider} handleClose={() => setShow(false)} />
        ) : (
          <Modal
            show
            centered
            onHide={() => setShow(false)}
            aria-labelledby={titleId}
            dialogClassName="custom-chat-sending-modal-width treatment-provider-chat-dialog"
            contentClassName="chat-sending-content treatment-provider-chat-content"
          >
            <Modal.Header className="chat-sending-header height-25 p-0 bg-primary popup-heading-color justify-content-center">
              <Modal.Title as="h2" id={titleId} className="chat-sending-title popup-heading-color">
                TreatmentFirst Account Required
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="chat-sending-body">
              <p className="m-0">
                You can only chat with providers who have an active TreatmentFirst account. Invite
                this provider to TreatmentFirst and wait for them to accept the invitation before
                sending a message.
              </p>
            </Modal.Body>
            <Modal.Footer className="chat-sending-footer">
              <Button
                type="button"
                variant="secondary"
                className="chat-sending-cancel"
                onClick={() => setShow(false)}
              >
                Close
              </Button>
              <Button
                type="button"
                variant="success"
                className="chat-sending-send"
                disabled={!provider?.id}
                onClick={() => {
                  setShow(false);
                  setShowInvite(true);
                }}
              >
                Invite Provider
              </Button>
            </Modal.Footer>
          </Modal>
        ))}
      {showInvite && (
        <InviteTreatmentModal
          show
          handleClose={() => setShowInvite(false)}
          caseProvider={provider}
          specialitie={specialty || provider?.specialty}
          refetchAll={refetchAll}
        />
      )}
    </>
  );
};

TreatmentFirstStatus.propTypes = {
  provider: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    provider: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]) }),
    provider_account_state: PropTypes.string,
    specialty: PropTypes.object,
  }),
  specialty: PropTypes.object,
  refetchAll: PropTypes.func,
};

export default TreatmentFirstStatus;
